// Apstag extensions
export default function loadApstagExtensions() {
  ((t = aps) => {
    window.apstag = window.apstag || {
      init: function (e, r) {
        t.record('legacy/init/enqueue', { config: e, callback: r });
      },
      fetchBids: function (e, r) {
        t.record('legacy/fetchBids/enqueue', { bidConfig: e, callback: r });
      },
      setDisplayBids: function () {
        t.run('legacy/setDisplayBids/enqueue', { arguments });
      },
      targetingKeys: function () {
        return t.read('legacy/targetingKeys') ?? [];
      },
      rpa: function (e, r, n) {
        t.record('legacy/rpa/enqueue', {
          tokenConfig: e,
          callback: r,
          setCookie: n,
        });
      },
      upa: function (e, r, n) {
        t.record('legacy/upa/enqueue', {
          tokenConfig: e,
          callback: r,
          setCookie: n,
        });
      },
      dpa: function (e) {
        t.record('legacy/dpa/enqueue', { callback: e });
      },
    };
    t.record('bootstrapExtAPStag/version/declare', { version: 1 });
  })();

  ((t = aps) => {
    window.apstag = {
      ...window.apstag,
      queue: {
        push: function (e) {
          t.record('legacy/queue/push', { callback: e });
        },
      },
    };
    t.record('bootstrapExtQueue/version/declare', { version: 1 });
  })();

  ((t = aps) => {
    window.apstag = {
      ...window.apstag,
      customPlacements: function () {
        return {
          hint: function (e, r, n) {
            t.record('customPlacement/hint/define', {
              id: e,
              isDefault: r,
              hintMetadata: n,
            });
          },
          enable: function () {
            t.record('customPlacement/service/enable');
          },
          addEventListener: function (e, r) {
            if (e === 'PlacementResponse') {
              t.react('customPlacement/placement/didRespond', r);
            } else {
              throw new Error('Unsupported event type');
            }
          },
        };
      },

    };
    t.record('bootstrapExtASR/version/declare', { version: 1 });
  })();

  ((t = aps) => {
    window.apstag = {
      ...window.apstag,
      nativeContent: function () {
        return {
          enable: function () {
            t.record('nativeCommerceAds/service/enable');
          },
          registerHook: function (e, r) {
            if (e === 'nativeCommerceAds.updateClickUrl') {
              t.react('nativeCommerceAds/clickUrl/update', (k) => {
                return {
                  status: 'completed',
                  value: { url: r(k?.detail?.url, k?.detail?.element) },
                };
              });
            } else {
              throw new Error('Unsupported event type');
            }
          },
        };
      },
    };
    t.record('bootstrapExtNCA/version/declare', { version: 1 });
  })();
}
